import { useTranslation } from 'react-i18next';
import { Col, Row, Radio, Form } from 'antd';
import { RadioItem, RadioItemInfo, RadioWrapper } from './styled';
import { Input } from './index';

const Resi = ({ returnType, retailOrRoot }) => {
  const { t } = useTranslation();
  const items = [
    {
      label: t('Spedizione reso sempre gratuito'),
      name: 'company_click_collect_attributes.return_type',
      checked: false,
      value: 'free',
    },
    {
      label: t('Costi spedizione reso a box'),
      name: 'company_click_collect_attributes.delivery_type_box',
      checked: false,
      value: 'box',
    },
    {
      label: t('Costi spedizione reso per soglia di acquisto'),
      name: 'company_click_collect_attributes.delivery_type_table',
      checked: false,
      value: 'table',
    },
  ];

  return (
    <Row>
      <Col span={24}>
        <Form.Item
          name={'company_click_collect_attributes.return_type'}
          // valuePropName='checked'
        >
          <Radio.Group disabled={!retailOrRoot}>
            <RadioWrapper>
              {items.map(({ ...item }, index) => (
                <RadioItem as='label' key={index} name={item.name}>
                  <RadioItemInfo>
                    <span>{item.label}</span>
                  </RadioItemInfo>
                  <Radio value={item.value} />
                </RadioItem>
              ))}
            </RadioWrapper>
          </Radio.Group>
        </Form.Item>
      </Col>
      <Col span={24}>
        {returnType === 'box' && (
          <>
            <Form.Item
              disabled={!retailOrRoot}
              name={'company_click_collect_attributes.return_box_price'}
              label={t('Costi spedizione a box')}
            >
              <Input />
            </Form.Item>
          </>
        )}
        {returnType === 'table' && (
          <>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.to_30'
              }
              label={t('Fino a € 30,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_30_to_50'
              }
              label={t('Da € 30,01 € 50,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_50_to_100'
              }
              label={t('Da € 50,01 a € 100,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_100_to_150'
              }
              label={t('Da € 100.01 a € 150,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_150_to_200'
              }
              label={t('Da € 150,01 a € 200,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_200_to_250'
              }
              label={t('Da € 200,01 a € 250,00')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
            <Form.Item
              name={
                'company_click_collect_attributes.company_table_prices.1.from_250'
              }
              label={t('Oltre € 250,01')}
            >
              <Input disabled={!retailOrRoot} />
            </Form.Item>
          </>
        )}
      </Col>
    </Row>
  );
};

export default Resi;
